module.exports = __webpack_public_path__ + "img/ring_0_0_null_null.96684dd7.png";